import {useAxiosGet} from "../../../infrastructure/http";
import {ReceiveDetailsResponse} from "../../../common/api/Models/ReceiveDetailsResponse";

export function useGetReceivePurchaseOrderDetails(purchaseOrderNumber: string,  invoiceNumber?: string, receiveId?: string, includeComments?: boolean, includeDraftReceive?: boolean) {
    let query: string[] = [];
    query.push("purchaseOrderNumber=" + purchaseOrderNumber);
    if (invoiceNumber) query.push("invoiceNumber=" + invoiceNumber);
    if (receiveId) query.push("receiveId=" + receiveId);
    if (includeComments) query.push("includeComments=true");
    if (includeDraftReceive) query.push("includeDraftReceive=true");
    let queryString = query.join("&");

    return useAxiosGet<ReceiveDetailsResponse>(`/ReceivePurchaseOrderDetails${(queryString ? "?" + queryString : "")}`, true);
}